import { useState } from 'react'

import type { IPlayerModel, IPlayerProps } from './player.types'

export const usePlayer = ({ url }: Pick<IPlayerProps, 'url'>): IPlayerModel => {
  const [playing, setPlaying] = useState(false)
  const [hasError, setHasError] = useState(false)

  const onPlayerPlay = () => setPlaying(true)
  const onPlayerPause = () => setPlaying(false)

  // Preserve legacy behavior: only flag an error when there is no URL to play.
  const onPlayerError = () => {
    if (!url) setHasError(true)
  }

  return { playing, hasError, onPlayerPlay, onPlayerPause, onPlayerError }
}
